import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
export const FORM_STATUS = {
    BUSY: 'BUSY',
    READY: 'READY'
};
const FormStatusContext = /*#__PURE__*/ createContext(undefined);
export const FormStatusProvider = ({ children, onStatusChange })=>{
    const previousFormStatus = useRef(FORM_STATUS.READY);
    const [fieldStatusByTarget, setFieldStatusByTarget] = useState({});
    const setFormStatus = useCallback((target, status)=>{
        setFieldStatusByTarget((previous)=>({
                ...previous,
                [target]: status
            }));
    }, []);
    const currentFormStatus = useMemo(()=>{
        const isFormBusy = Object.values(fieldStatusByTarget).some((status)=>status === FORM_STATUS.BUSY);
        return isFormBusy ? FORM_STATUS.BUSY : FORM_STATUS.READY;
    }, [
        fieldStatusByTarget
    ]);
    useEffect(()=>{
        if (previousFormStatus.current !== currentFormStatus) {
            previousFormStatus.current = currentFormStatus;
            onStatusChange?.(currentFormStatus);
        }
    }, [
        currentFormStatus,
        onStatusChange
    ]);
    const contextValue = useMemo(()=>{
        return {
            formStatus: currentFormStatus,
            setFormStatus
        };
    }, [
        currentFormStatus,
        setFormStatus
    ]);
    return /*#__PURE__*/ React.createElement(FormStatusContext.Provider, {
        value: contextValue
    }, children);
};
export function useFormStatus() {
    const context = useContext(FormStatusContext);
    if (context === undefined) {
        throw new Error('useFormStatus must be used within a Form Status provider');
    }
    return context;
}

//# sourceMappingURL=form-status-provider.js.map